{
  "identities.messages.1010001": "Wọlé",
  "identities.messages.1010002": "Wọlé pẹ̀lú {provider}",
  "identities.messages.1010003": "Jọ̀wọ́ jẹ́rìí ìṣe yìí nípa fífi múlẹ̀ pé ìwọ nì ó.",
  "identities.messages.1010004": "Jọ̀wọ́ parí ìdánwò ìjẹ́rìísí kejì.",
  "identities.messages.1010005": "Jẹ́rìí",
  "identities.messages.1010006": "Kóòdù ìjẹ́rìísí",
  "identities.messages.1010007": "Kóòdù ìgbàpadà àtúnbẹ̀rẹ̀",
  "identities.messages.1010008": "Tẹ̀síwájú pẹ̀lú kọ́kọ́rọ́ ohun èlò",
  "identities.messages.1010009": "Tẹ̀síwájú",
  "identities.messages.1010010": "Tẹ̀síwájú",
  "identities.messages.1010011": "Wọlé pẹ̀lú kọ́kọ́rọ́ ohun èlò",
  "identities.messages.1010012": "Múra ẹ̀rọ WebAuthn rẹ (b.a. kọ́kọ́rọ́ àbò, ẹ̀rọ àyẹ̀wò ìwọ̀n-ara, ...) kí o sì tẹ tẹ̀síwájú.",
  "identities.messages.1010013": "Tẹ̀síwájú",
  "identities.messages.1010014": "A ti fi kóòdù kan ránṣẹ́ sí àdírẹ́ẹ̀sì tí o pèsè. Tí o kò bá gbà á, jọ̀wọ́ ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì gbìyànjú lẹ́ẹ̀kan sí i.",
  "identities.messages.1010015": "Fi kóòdù wíwọlé ránṣẹ́",
  "identities.messages.1010016": "O gbìyànjú láti wọlé pẹ̀lú \"{duplicateIdentifier}\", ṣùgbọ́n ìméèlì yẹn ti wà lọ́wọ́ àkọ́ọ̀lẹ̀ mìíràn. Wọlé sí àkọ́ọ̀lẹ̀ rẹ pẹ̀lú ọ̀kan nínú àwọn àṣàyàn ìsàlẹ̀ láti fi àkọ́ọ̀lẹ̀ rẹ \"{duplicateIdentifier}\" ní \"{provider}\" kún bí ọ̀nà mìíràn láti wọlé.",
  "identities.messages.1010017": "Wọlé kí o sì so pọ̀",
  "identities.messages.1010018": "Jẹ́rìí pẹ̀lú {provider}",
  "identities.messages.1010019": "Béèrè kóòdù láti tẹ̀síwájú",
  "identities.messages.1010021": "Wọlé pẹ̀lú passkey",
  "identities.messages.1010022": "Wọlé pẹ̀lú ọ̀rọ̀ aṣínà",
  "identities.messages.1010023": "Fi kóòdù ránṣẹ́ sí {address}",
  "identities.messages.1040001": "Forúkọsílẹ̀",
  "identities.messages.1040002": "Forúkọsílẹ̀ pẹ̀lú {provider}",
  "identities.messages.1040003": "Tẹ̀síwájú",
  "identities.messages.1040004": "Forúkọsílẹ̀ pẹ̀lú kọ́kọ́rọ́ àbò",
  "identities.messages.1040005": "A ti fi kóòdù kan ránṣẹ́ sí àdírẹ́ẹ̀sì tí o pèsè. Tí o kò bá tí gba ìfiránṣẹ́, ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì tún ìforúkọsílẹ̀ náà gbìyànjú.",
  "identities.messages.1040006": "Fi kóòdù ìforúkọsílẹ̀ ránṣẹ́",
  "identities.messages.1040007": "Forúkọsílẹ̀ pẹ̀lú passkey",
  "identities.messages.1040008": "Padà",
  "identities.messages.1040009": "Jọ̀wọ́ yan ẹ̀rí ìdánimọ̀ kan láti fi jẹ́rìí ara rẹ.",
  "identities.messages.1050001": "A ti fi àwọn àyípadà rẹ pamọ́!",
  "identities.messages.1050002": "So {provider} pọ̀",
  "identities.messages.1050003": "Yọ {provider} kúrò",
  "identities.messages.1050004": "Yọ Ohun Èlò Àjẹ́rìí TOTP kúrò",
  "identities.messages.1050005": "Kóòdù QR ohun èlò àjẹ́rìí",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Ṣí àwọn kóòdù ìgbàpadà àtúnbẹ̀rẹ̀",
  "identities.messages.1050008": "Mú ṣiṣẹ́",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Èyí jẹ́ àwọn kóòdù ìgbàpadà àtúnbẹ̀rẹ̀ rẹ. Jọ̀wọ́ tọ́jú wọn ní ibí tí ó ní àbò!",
  "identities.messages.1050011": "Jẹ́rìí àwọn kóòdù ìgbàpadà àtúnbẹ̀rẹ̀",
  "identities.messages.1050012": "Fi kọ́kọ́rọ́ àbò kún",
  "identities.messages.1050013": "Orúkọ kọ́kọ́rọ́ àbò náà",
  "identities.messages.1050014": "A ti lo aṣínà ní {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Pa ọ̀nà yìí",
  "identities.messages.1050017": "Ìkọkọ alájẹ́rìí",
  "identities.messages.1050018": "Yọ kọ́kọ́rọ́ àbò \"{display_name}\" kúrò",
  "identities.messages.1050019": "Fi passkey kún",
  "identities.messages.1050020": "Yọ passkey \"{display_name}\" kúrò",
  "identities.messages.1060001": "O ti gba àkọ́ọ̀lẹ̀ rẹ padà ní àṣeyọrí. Jọ̀wọ́ yí ọ̀rọ̀ aṣínà rẹ padà tàbí ṣètò ọ̀nà wíwọlé mìíràn (b.a. wíwọlé àwùjọ) láàrín ìṣẹ́jú {privileged_session_expires_at_unix_until_minutes} tí ó kù.",
  "identities.messages.1060002": "A ti fi ìméèlì tí ó ní líǹkì ìgbàpadà ránṣẹ́ sí àdírẹ́ẹ̀sì ìméèlì tí o pèsè. Tí o kò bá tí gba ìméèlì, ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì rí i dájú pé o lo àdírẹ́ẹ̀sì tí o fi forúkọsílẹ̀.",
  "identities.messages.1060003": "A ti fi ìméèlì tí ó ní kóòdù ìgbàpadà ránṣẹ́ sí àdírẹ́ẹ̀sì ìméèlì tí o pèsè. Tí o kò bá tí gba ìméèlì, ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì rí i dájú pé o lo àdírẹ́ẹ̀sì tí o fi forúkọsílẹ̀.",
  "identities.messages.1060004": "A ti fi kóòdù ìgbàpadà ránṣẹ́ sí \"{masked_address}\". Tí o kò bá tí gbà á, ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì rí i dájú pé o lo àdírẹ́ẹ̀sì tí o fi forúkọsílẹ̀.",
  "identities.messages.1060005": "Gba ìwọlé sí àkọ́ọ̀lẹ̀ rẹ padà nípa pípèsè àdírẹ́ẹ̀sì ìgbàpadà rẹ ní kíkún.",
  "identities.messages.1060006": "Báwo ni o ṣe fẹ́ gba àkọ́ọ̀lẹ̀ rẹ padà?",
  "identities.messages.1060007": "Padà",
  "identities.messages.1070001": "Ọ̀rọ̀ aṣínà",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Fi pamọ́",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Fi rán",
  "identities.messages.1070006": "Jẹ́rìí kóòdù",
  "identities.messages.1070007": "Ìméèlì",
  "identities.messages.1070008": "Tún kóòdù ránṣẹ́",
  "identities.messages.1070009": "Tẹ̀síwájú",
  "identities.messages.1070010": "Kóòdù ìgbàpadà",
  "identities.messages.1070011": "Kóòdù ìjẹ́rìísí",
  "identities.messages.1070012": "Kóòdù ìforúkọsílẹ̀",
  "identities.messages.1070013": "Kóòdù wíwọlé",
  "identities.messages.1070014": "Wọlé kí o sì so ẹ̀rí ìdánimọ̀ pọ̀",
  "identities.messages.1070015": "Jọ̀wọ́ parí ìdánwò captcha láti tẹ̀síwájú.",
  "identities.messages.1070016": "Àdírẹ́ẹ̀sì ìgbàpadà",
  "identities.messages.1070017": "Nọ́mbà fóònù",
  "identities.messages.1080001": "A ti fi ìméèlì tí ó ní líǹkì ìjẹ́rìísí ránṣẹ́ sí àdírẹ́ẹ̀sì ìméèlì tí o pèsè. Tí o kò bá tí gba ìméèlì, ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì rí i dájú pé o lo àdírẹ́ẹ̀sì tí o fi forúkọsílẹ̀.",
  "identities.messages.1080002": "O ti jẹ́rìí àdírẹ́ẹ̀sì ìméèlì rẹ ní àṣeyọrí.",
  "identities.messages.1080003": "A ti fi ìméèlì tí ó ní kóòdù ìjẹ́rìísí ránṣẹ́ sí àdírẹ́ẹ̀sì ìméèlì tí o pèsè. Tí o kò bá tí gba ìméèlì, ṣàyẹ̀wò lẹ́tà àdírẹ́ẹ̀sì náà kí o sì rí i dájú pé o lo àdírẹ́ẹ̀sì tí o fi forúkọsílẹ̀.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Jọ̀wọ́ tẹ {property} sínú kí o sì tún gbìyànjú.",
  "identities.messages.4000003": "gígùn gbọdọ̀ jẹ́ >= {min_length}, ṣùgbọ́n o gbà {actual_length}",
  "identities.messages.4000004": "kò bá ìlànà \"{pattern}\" mu",
  "identities.messages.4000005": "A kò lè lo ọ̀rọ̀ aṣínà náà nítorí {reason}.",
  "identities.messages.4000006": "Àwọn ẹ̀rí ìdánimọ̀ tí a pèsè kò tọ́, ṣàyẹ̀wò àwọn àṣìṣe lẹ́tà nínú ọ̀rọ̀ aṣínà tàbí orúkọ oníṣe, àdírẹ́ẹ̀sì ìméèlì, tàbí nọ́mbà fóònù rẹ.",
  "identities.messages.4000007": "Àkọ́ọ̀lẹ̀ tí ó ní ìdánimọ̀ kannáà (ìméèlì, fóònù, orúkọ oníṣe, ...) ti wà tẹ́lẹ̀.",
  "identities.messages.4000008": "Kóòdù ìjẹ́rìísí tí a pèsè kò tọ́, jọ̀wọ́ tún gbìyànjú.",
  "identities.messages.4000009": "A kò rí àwọn ìdánimọ̀ wíwọlé kankan. Ṣé o gbàgbé láti ṣètò wọn? Èyí tún lè jẹ́ nítorí àṣìṣe ìṣètò ìsàlẹ̀.",
  "identities.messages.4000010": "Àkọ́ọ̀lẹ̀ kò tíì ṣiṣẹ́. Ṣé o gbàgbé láti jẹ́rìí àdírẹ́ẹ̀sì ìméèlì rẹ?",
  "identities.messages.4000011": "O kò ní ẹ̀rọ TOTP tí a ṣètò.",
  "identities.messages.4000012": "A ti lo kóòdù ìgbàpadà àtúnbẹ̀rẹ̀ yìí tẹ́lẹ̀.",
  "identities.messages.4000013": "O kò ní ẹ̀rọ WebAuthn tí a ṣètò.",
  "identities.messages.4000014": "O kò ní àwọn kóòdù ìgbàpadà àtúnbẹ̀rẹ̀ tí a ṣètò.",
  "identities.messages.4000015": "Àkọ́ọ̀lẹ̀ yìí kò sí tàbí kò ní kọ́kọ́rọ́ àbò tí a ṣètò.",
  "identities.messages.4000016": "Kóòdù ìgbàpadà àtúnbẹ̀rẹ̀ náà kò tọ́.",
  "identities.messages.4000017": "gígùn gbọdọ̀ jẹ́ <= {max_length}, ṣùgbọ́n o gbà {actual_length}",
  "identities.messages.4000018": "gbọdọ̀ jẹ́ >= {minimum} ṣùgbọ́n a rí {actual}",
  "identities.messages.4000019": "gbọdọ̀ jẹ́ > {minimum} ṣùgbọ́n a rí {actual}",
  "identities.messages.4000020": "gbọdọ̀ jẹ́ <= {maximum} ṣùgbọ́n a rí {actual}",
  "identities.messages.4000021": "gbọdọ̀ jẹ́ < {maximum} ṣùgbọ́n a rí {actual}",
  "identities.messages.4000022": "{actual} kìí ṣe ọ̀pọ̀lọpọ̀ ti {base}",
  "identities.messages.4000023": "ọ̀pọ̀ {max_items} àwọn ohun tí a gbà láàyè, ṣùgbọ́n a rí {actual_items} àwọn ohun",
  "identities.messages.4000024": "kéré {min_items} àwọn ohun tí a gbà láàyè, ṣùgbọ́n a rí {actual_items} àwọn ohun",
  "identities.messages.4000025": "àwọn ohun ní atọ́ka {index_a} àti {index_b} jọra",
  "identities.messages.4000026": "a ń retí {allowed_types_list}, ṣùgbọ́n a gbà {actual_type}",
  "identities.messages.4000027": "Àkọ́ọ̀lẹ̀ tí ó ní ìdánimọ̀ kannáà (ìméèlì, fóònù, orúkọ oníṣe, ...) ti wà tẹ́lẹ̀. Jọ̀wọ́ wọlé sí àkọ́ọ̀lẹ̀ tí ó wà tẹ́lẹ̀ láti so profaili àwùjọ rẹ pọ̀.",
  "identities.messages.4000028": "O gbìyànjú wíwọlé pẹ̀lú {credential_identifier_hint} tí ó ti wà lọ́wọ́ àkọ́ọ̀lẹ̀ mìíràn. O lè wọlé nípa lílo {available_credential_types_list}. O lè wọlé nípa lílo ọ̀kan nínú àwọn olùpèsè wíwọlé àwùjọ wọ̀nyí: {available_oidc_providers_list}.",
  "identities.messages.4000029": "gbọdọ̀ dọ́gba pẹ̀lú ìdúróṣinṣin {expected}",
  "identities.messages.4000030": "ìdúróṣinṣin kùnà",
  "identities.messages.4000031": "A kò lè lo ọ̀rọ̀ aṣínà náà nítorí pé ó jọra pẹ̀lú ìdánimọ̀ náà.",
  "identities.messages.4000032": "Ọ̀rọ̀ aṣínà gbọdọ̀ jẹ́ ó kéré jù lẹ́tà {min_length}, ṣùgbọ́n o gbà {actual_length}.",
  "identities.messages.4000033": "Ọ̀rọ̀ aṣínà gbọdọ̀ jẹ́ ó pọ̀ jù lẹ́tà {max_length}, ṣùgbọ́n o gbà {actual_length}.",
  "identities.messages.4000034": "A ti rí ọ̀rọ̀ aṣínà náà nínú àwọn ìfọ́ dátà kò sì gbọdọ̀ lo mọ́.",
  "identities.messages.4000035": "Àkọ́ọ̀lẹ̀ yìí kò sí tàbí kò tíì ṣètò wíwọlé pẹ̀lú kóòdù.",
  "identities.messages.4000036": "Àwọn àbùdá tí a pèsè kò bá àwọn àbùdá tí a ṣe ìsopọ̀ pẹ̀lú ṣíṣan yìí tẹ́lẹ̀ mu.",
  "identities.messages.4000037": "Àkọ́ọ̀lẹ̀ yìí kò sí tàbí kò ní ọ̀nà wíwọlé tí a ṣètò.",
  "identities.messages.4000038": "Ìjẹ́rìísí Captcha kùnà, jọ̀wọ́ tún gbìyànjú.",
  "identities.messages.4010001": "Ìgbéríyìn rẹ̀ ti parí. Jọ̀wọ́, gbìyànjú lẹ́ẹ̀kàn.",
  "identities.messages.4010002": "A kò rí ìlànà láti fi wọlé. Ṣé o kún fọ́ọ̀mù náà tọ́?",
  "identities.messages.4010003": "A kò rí ìlànà láti fi forúkọsílẹ̀. Ṣé o kún fọ́ọ̀mù náà tọ́?",
  "identities.messages.4010004": "A kò rí ìlànà láti yí àwọn ètò rẹ padà. Ṣé o kún fọ́ọ̀mù náà tọ́?",
  "identities.messages.4010005": "A kò rí ìlànà láti gba àkọ́ọ̀lẹ̀ rẹ padà. Ṣé o kún fọ́ọ̀mù náà tọ́?",
  "identities.messages.4010006": "A kò rí ìlànà láti jẹ́rìí àkọ́ọ̀lẹ̀ rẹ. Ṣé o kún fọ́ọ̀mù náà tọ́?",
  "identities.messages.4010007": "A ti parí ìbéèrè náà ní àṣeyọrí kò sì lè tún gbìyànjú.",
  "identities.messages.4010008": "Kóòdù wíwọlé kò tọ́ tàbí a ti lò ó tẹ́lẹ̀. Jọ̀wọ́ tún gbìyànjú.",
  "identities.messages.4010009": "Àwọn ẹ̀rí ìdánimọ̀ tí a so pọ̀ kò bá ara wọn mu.",
  "identities.messages.4010010": "Àdírẹ́ẹ̀sì tí o tẹ sínú kò bá àwọn àdírẹ́ẹ̀sì tí a mọ̀ nínú àkọ́ọ̀lẹ̀ lọ́wọ́lọ́wọ́ mu.",
  "identities.messages.4040001": "Ìgbéríyìn rẹ̀ ti parí. Jọ̀wọ́, gbìyànjú lẹ́ẹ̀kàn.",
  "identities.messages.4040002": "A ti parí ìbéèrè náà ní àṣeyọrí kò sì lè tún gbìyànjú.",
  "identities.messages.4040003": "Kóòdù ìforúkọsílẹ̀ kò tọ́ tàbí a ti lò ó tẹ́lẹ̀. Jọ̀wọ́ tún gbìyànjú.",
  "identities.messages.4050001": "Ìgbéríyìn rẹ̀ ti parí. Jọ̀wọ́, gbìyànjú lẹ́ẹ̀kàn.",
  "identities.messages.4060001": "A ti parí ìbéèrè náà ní àṣeyọrí kò sì lè tún gbìyànjú.",
  "identities.messages.4060002": "Ìṣàn ìgbàpadà dé ipò ìkùnà gbọdọ̀ sì tún gbìyànjú.",
  "identities.messages.4060004": "Àmì ìgbàpadà kò tọ́ tàbí a ti lò ó tẹ́lẹ̀. Jọ̀wọ́ tún ìṣàn náà gbìyànjú.",
  "identities.messages.4060005": "Ìgbéríyìn rẹ̀ ti parí. Jọ̀wọ́, gbìyànjú lẹ́ẹ̀kàn.",
  "identities.messages.4060006": "Kóòdù ìgbàpadà kò tọ́ tàbí a ti lò ó tẹ́lẹ̀. Jọ̀wọ́ tún gbìyànjú.",
  "identities.messages.4070001": "Àmì ìjẹ́rìísí kò tọ́ tàbí a ti lò ó tẹ́lẹ̀. Jọ̀wọ́ tún ìṣàn náà gbìyànjú.",
  "identities.messages.4070002": "A ti parí ìbéèrè náà ní àṣeyọrí kò sì lè tún gbìyànjú.",
  "identities.messages.4070003": "Ìṣàn ìjẹ́rìísí dé ipò ìkùnà gbọdọ̀ sì tún gbìyànjú.",
  "identities.messages.4070005": "Ìgbéríyìn rẹ̀ ti parí. Jọ̀wọ́, gbìyànjú lẹ́ẹ̀kàn.",
  "identities.messages.4070006": "Kóòdù ìjẹ́rìísí kò tọ́ tàbí a ti lò ó tẹ́lẹ̀. Jọ̀wọ́ tún gbìyànjú.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "Jáde",
  "login.registration-button": "Forúkọsílẹ̀",
  "login.registration-label": "O kò ní àkọ́ọ̀lẹ̀?",
  "login.title": "Wọlé",
  "login.subtitle": "Wọlé pẹ̀lú {parts}",
  "login.title-aal2": "Ìjẹ́rìísí ìpele kejì",
  "login.subtitle-aal2": "Yan ọ̀nà kan láti parí ìjẹ́rìísí ìpele kejì rẹ",
  "login.code.subtitle": "A máa fi kóòdù ìjẹ́rìísí ránṣẹ́ nípa ìméèlì",
  "login.webauthn.subtitle": "Jọ̀wọ́ múra ẹ̀rọ WebAuthN rẹ",
  "login.totp.subtitle": "Jọ̀wọ́ tẹ kóòdù tí Ohun Èlò Àjẹ́rìí rẹ ṣe",
  "login.lookup_secret.subtitle": "Jọ̀wọ́ tẹ ọ̀kan nínú àwọn kóòdù ìgbàpadà àtúnbẹ̀rẹ̀ 8-nọ́mbà rẹ",
  "login.title-refresh": "Tún jẹ́rìí",
  "login.subtitle-refresh": "Jẹ́rìí ìdánimọ̀ rẹ pẹ̀lú {parts}",
  "login.2fa.go-back": "Ohunkan kò ṣiṣẹ́?",
  "login.2fa.go-back.link": "Padà sẹ́yìn",
  "login.2fa.method.go-back": "Yan ọ̀nà mìíràn",
  "recovery.title": "Gba àkọ́ọ̀lẹ̀ rẹ padà",
  "recovery.subtitle": "Tẹ ìdánimọ̀ tí a ṣe ìsopọ̀ pẹ̀lú àkọ́ọ̀lẹ̀ rẹ láti gba kóòdù ìwọlé ẹ̀ẹ̀kan-ṣoṣo",
  "registration.login-button": "Wọlé",
  "registration.login-label": "Ṣé o ti ní àkọ́ọ̀lẹ̀ tẹ́lẹ̀?",
  "registration.title": "Forúkọsílẹ̀ àkọ́ọ̀lẹ̀",
  "registration.subtitle": "Forúkọsílẹ̀ pẹ̀lú {parts}",
  "settings.navigation-back-button": "Padà",
  "settings.subtitle": "Yí àwọn ètò àkọ́ọ̀lẹ̀ rẹ padà",
  "settings.title": "Àwọn Ètò Àkọ́ọ̀lẹ̀",
  "settings.password.title": "Yí Ọ̀rọ̀ Aṣínà Padà",
  "settings.password.description": "Yí ọ̀rọ̀ aṣínà rẹ padà",
  "settings.profile.title": "Àwọn Ètò Profaili",
  "settings.profile.description": "Yí ìròyìn profaili rẹ padà",
  "settings.webauthn.title": "Ṣàkóso Àwọn Àmì Ohun Èlò",
  "settings.webauthn.description": "Ṣàkóso àwọn ètò àmì ohun èlò rẹ",
  "settings.messages.toast-title.success": "A ti yí àwọn ètò padà",
  "settings.messages.toast-title.error": "A kò lè yí àwọn ètò padà",
  "verification.title": "Jẹ́rìí àkọ́ọ̀lẹ̀ rẹ",
  "verification.subtitle": "Tẹ àdírẹ́ẹ̀sì ìméèlì tí a ṣe ìsopọ̀ pẹ̀lú àkọ́ọ̀lẹ̀ rẹ láti jẹ́rìí rẹ̀",
  "two-step.password.title": "Ọ̀rọ̀ aṣínà",
  "two-step.password.description": "Tẹ ọ̀rọ̀ aṣínà tí a ṣe ìsopọ̀ pẹ̀lú àkọ́ọ̀lẹ̀ rẹ",
  "two-step.code.title": "Kóòdù ìméèlì",
  "two-step.code.description": "A máa fi kóòdù ìjẹ́rìísí ránṣẹ́ sí ìméèlì rẹ",
  "two-step.webauthn.title": "Kọ́kọ́rọ́ àbò",
  "two-step.webauthn.description": "Lo kọ́kọ́rọ́ àbò rẹ láti jẹ́rìí",
  "two-step.passkey.title": "Passkey (a ṣe ìmọ̀ràn)",
  "two-step.passkey.description": "Lo ẹ̀rọ rẹ fún ìtẹ̀lẹ́mọ́wé tàbí ìdánimọ̀ ojú",
  "two-step.passkey.description.error": "A kò lè gba àwọn ilé-iṣẹ́ tí ó ṣe pàtàkì láti lo Passkey rẹ. Jọ̀wọ́ tún gbìyànjú lẹ́yìn.",
  "two-step.totp.title": "Lo Ohun Èlò Àjẹ́rìí rẹ (TOTP)",
  "two-step.totp.description": "Lo kóòdù ẹ̀ẹ̀kan-ṣoṣo 6-nọ́mbà láti ohun èlò àjẹ́rìí rẹ",
  "two-step.lookup_secret.title": "Kóòdù ìgbàpadà àtúnbẹ̀rẹ̀",
  "two-step.lookup_secret.description": "Lo ọ̀kan nínú àwọn kóòdù àtúnbẹ̀rẹ̀ 8-nọ́mbà rẹ láti jẹ́rìí",
  "input.placeholder": "Tẹ {placeholder} rẹ sínú",
  "card.header.parts.oidc": "olùpèsè àwùjọ",
  "card.header.parts.password.registration": "{identifierLabel} rẹ àti ọ̀rọ̀ aṣínà",
  "card.header.parts.password.login": "{identifierLabel} rẹ àti ọ̀rọ̀ aṣínà",
  "card.header.parts.code": "kóòdù ẹ̀ẹ̀kan-ṣoṣo",
  "card.header.parts.passkey": "Passkey",
  "card.header.parts.webauthn": "kọ́kọ́rọ́ àbò",
  "card.header.parts.totp": "ohun èlò àjẹ́rìí rẹ",
  "card.header.parts.lookup_secret": "kóòdù ìgbàpadà àtúnbẹ̀rẹ̀",
  "card.header.parts.identifier-first": "{identifierLabel} rẹ",
  "misc.or": "tàbí",
  "forms.label.forgot-password": "Ṣé o gbàgbé Ọ̀rọ̀ Aṣínà?",
  "forms.label.recover-account": "Gba Àkọ́ọ̀lẹ̀ Padà",
  "settings.totp.title": "Ohun Èlò Àjẹ́rìí",
  "settings.totp.description": "Fi Ohun Èlò Àjẹ́rìí TOTP kún sí àkọ́ọ̀lẹ̀ rẹ láti mu àbò àkọ́ọ̀lẹ̀ rẹ dára sí i. Àwọn Ohun Èlò Àjẹ́rìí tí ó gbajúmọ̀ ni LastPass àti Google Authenticator",
  "settings.totp.info.not-linked": "Láti mú ṣiṣẹ́ ṣàyẹ̀wò kóòdù QR pẹ̀lú àjẹ́rìí rẹ kí o sì tẹ kóòdù náà.",
  "settings.totp.info.linked": "O ní ohun èlò àjẹ́rìí tí a sopọ̀ ní ìṣinsìnyí.",
  "settings.lookup_secret.title": "Àwọn Kóòdù Ìgbàpadà Àtúnbẹ̀rẹ̀ (ìpele kejì)",
  "settings.lookup_secret.description": "Àwọn kóòdù ìgbàpadà jẹ́ àtúnbẹ̀rẹ̀ àbò fún 2FA, tí ó ń jẹ́ kí o tún gba ìwọlé sí àkọ́ọ̀lẹ̀ rẹ tí o bá sọ ẹ̀rọ 2FA rẹ nù.",
  "settings.oidc.title": "Àwọn àkọ́ọ̀lẹ̀ tí a sopọ̀",
  "settings.oidc.description": "So olùpèsè wíwọlé àwùjọ pọ̀ pẹ̀lú àkọ́ọ̀lẹ̀ rẹ.",
  "settings.oidc.info": "A lè lo àwọn àkọ́ọ̀lẹ̀ tí a sopọ̀ láti àwọn olùpèsè wọ̀nyí láti wọlé sí àkọ́ọ̀lẹ̀ rẹ",
  "settings.webauthn.info": "A ń lo Àwọn Àmì Ohun Èlò fún ìjẹ́rìísí ìpele-kejì tàbí bí ìpele-àkọ́kọ́ pẹ̀lú Àwọn Passkey",
  "settings.passkey.title": "Ṣàkóso Àwọn Passkey",
  "settings.passkey.description": "Ṣàkóso àwọn ètò passkey rẹ",
  "settings.passkey.info": "Ṣàkóso àwọn ètò passkey rẹ",
  "card.footer.select-another-method": "Yan ọ̀nà mìíràn",
  "account-linking.title": "So àkọ́ọ̀lẹ̀ pọ̀",
  "property.password": "ọ̀rọ̀ aṣínà",
  "property.email": "ìméèlì",
  "property.phone": "fóònù",
  "property.username": "orúkọ oníṣe",
  "property.identifier": "ìdánimọ̀",
  "property.code": "kóòdù",
  "property.recovery_address": "àdírẹ́ẹ̀sì ìgbàpadà",
  "consent.title": "Fun {party} ní àṣẹ",
  "consent.subtitle": "Ohun èlò ẹ̀kẹta kan fẹ́ wọlé sí ìròyìn tí a ṣe ìsopọ̀ pẹ̀lú àkọ́ọ̀lẹ̀ rẹ {identifier}.",
  "consent.scope.openid.title": "Ìdánimọ̀",
  "consent.scope.openid.description": "Ó fún ohun èlò náà láàyè láti jẹ́rìí ìdánimọ̀ rẹ. Èyí ṣe pàtàkì fún ìjẹ́rìísí àti ìrírí wíwọlé tí ó ní ìgbẹ́kẹ̀lé.",
  "consent.scope.offline_access.title": "Ìwọlé Àìsí-lórí",
  "consent.scope.offline_access.description": "Ó fún ohun èlò yìí láàyè láti jẹ́ kí o wọlé páàpáà nígbà tí o kò bá ń lò ó lọ́wọ́lọ́wọ́.",
  "consent.scope.profile.title": "Ìròyìn Profaili",
  "consent.scope.profile.description": "Ó fún ní àyè sí àwọn àlàyé profaili ìpìlẹ̀ rẹ, pẹ̀lú orúkọ oníṣe rẹ, orúkọ àkọ́kọ́, àti orúkọ ìdílé.",
  "consent.scope.email.title": "Àdírẹ́ẹ̀sì Ìméèlì",
  "consent.scope.email.description": "Gba àdírẹ́ẹ̀sì ìméèlì rẹ àti ipò ìjẹ́rìísí rẹ̀.",
  "consent.scope.address.title": "Àdírẹ́ẹ̀sì Ti-ara",
  "consent.scope.address.description": "Wọlé sí àdírẹ́ẹ̀sì ìfowópamọ́ rẹ.",
  "consent.scope.phone.title": "Nọ́mbà Fóònù",
  "consent.scope.phone.description": "Gba nọ́mbà fóònù rẹ àti ipò ìjẹ́rìísí rẹ̀.",
  "error.title.what-happened": "Kí ni ó ṣẹlẹ̀?",
  "error.title.what-can-i-do": "Kí ni mo lè ṣe?",
  "error.instructions": "Jọ̀wọ́ tún gbìyànjú ní ìṣẹ́jú díẹ̀ tàbí kan sí oluṣàkóso ààyè náà.",
  "error.footer.text": "Nígbà tí o bá ń ròyìn àṣìṣe yìí, jọ̀wọ́ kó ìròyìn wọ̀nyí wọlé:",
  "error.footer.copy": "Ṣẹ̀dà",
  "error.action.go-back": "Padà sẹ́yìn",
  "identities.messages.4000039": "Ọrọ igbaniwọle tuntun gbọdọ yatọ si ọrọ igbaniwọle atijọ.",
  "identities.messages.4000040": "Tẹ adirẹsi imeeli to wulo",
  "identities.messages.4000041": "Tẹ nọmba foonu to wulo",
  "captcha.error": "Ijẹrisi aabo kuna. Jọwọ gbiyanju lẹẹkansi nigbamii. Ti iṣoro naa ba tẹsiwaju, kan si atilẹyin.",
  "identities.messages.5000002": "Kò sí ọ̀nà kan tí ó lè ṣẹ̀dáàfí. Jọ̀wọ́, fọ̀wọ́sí ọ̀jọ̀gbọ́n ètò náà.",
  "identities.messages.4010011": "Àkọ́ọ́ntì yí ti di ìdámọ́. Jọ̀wọ́, ṣe àfẹ́rànjú pẹ̀lú ẹni tí o lè rànlọ́wọ́.",
  "identities.messages.1070018": "Àdèsì èlò-ìwélétà tí ó ní lórí ìnternẹ́tì tàbí númbá foonu rẹ.",
  "identities.messages.1080004": "Ọ̀ráǹráń kan tí o ní kóòdú ìdámímúra ti wá láti ojú-èrò rẹ̀ sí núm̀bá foonù tí o fún wà. Bí o bá kọ̀ ní o ti gbá ọ̀ráǹráń kan, ṣàyé kí o ríi bí o ti kọ́ núm̀bá náà, kí o tún rii pé o ń lo núm̀bá tí o ti fọ̀rán sẹ̀.",
  "identities.messages.1080005": "O ti ṣe ìdánimọ̀ nọ́mbà foonù rẹ.",
  "identities.messages.5000003": "Àjọ rẹ nilo ìdánimọ́ SSO, ṣùgbọ́ kò sí onísọ́dí ìdánimọ́ SSO tí a ṣètò. Jọ̀wọ́, bá olùṣepọ̀ ètò náà sọ̀rọ̀.",
  "identities.messages.1010024": "Wọlé pẹ̀lú aami ohun elétíríkì",
  "identities.messages.1010025": "A ti ranṣẹ koodu kan si adirẹsi rẹ. Bí o kò bá gbà á, jọwọ gbiyanju lẹẹkansi.",
  "identities.messages.4000042": "Ẹ kò sọ́ ẹrọ DeviceAuthn kan tí o ti ṣètọ́.",
  "identities.messages.4000043": "Ìfarabalẹ̀ wẹ́bù àmójúwọ́ tí o fúnni rẹ̀ kò tọ́, jọ̀wọ̀ gbìyànjú lẹ́ẹ̀kàn.",
  "identities.messages.4000044": "Aamí tí a fún un láti ṣé ìdámọ́ pẹ̀lú ẹrọ rẹ̀, kíí ṣe.",
  "identities.messages.4050002": "O le yi àdírésì kan nìkan lọ́ náà. Jọ̀wọ́, ṣe àtúnṣe àdírésì kọ̀ọ̀kan lóríì."
}
